export const getVariantImage = (variants, type) => {
  switch (type) {
    case 'master':
      return variants?.master?.link;
    case 'preview':
      return variants?.preview?.link;
    case 'thumbnail':
      return variants?.thumbnail?.link;
    default:
      return null;
  }
};
